import React from 'react';
import { Link } from 'gatsby';

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: '',
    };
  }

  pathIncludes = (word) => {
    if (typeof window !== 'undefined') {
      return window.location.href.includes(word) ? 'navbar-item--active' : '';
    }
    return '';
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
            navBarActiveClass: 'is-active',
          })
          : this.setState({
            navBarActiveClass: '',
          });
      },
    );
  }

  closeHamburger = () => {
    this.setState({
      active: false,
    }, () => {
      this.setState({
        navBarActiveClass: '',
      });
    });
  }

  render() {
    return (
      <nav
        className="navbar is-transparent is-fixed-top"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className={`container is-fluid ${this.state.navBarActiveClass}`}>
          <div className="navbar-brand">
            <Link to="/" className="navbar-item nav-logo" title="Logo">
              <div className="nav-logo">
                <h3 className="title--techfont">O</h3>
              </div>
              {/* <img src={logo} alt="Kaldi" style={{ width: '88px' }} /> */}
            </Link>
            {/* Hamburger menu */}
            <div
              role="button"
              tabIndex={0}
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
              onKeyDown={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered">
              <Link className={`navbar-item ${this.pathIncludes('services')}`} to="/services">
                <p>Services</p>
              </Link>
              <Link className={`navbar-item ${this.pathIncludes('case-studies')}`} to="/case-studies">
                <p>Case studies</p>
              </Link>
              {/* <Link className={'navbar-item ' + this.pathIncludes('about')}to="/blog">
                RESOURCES
              </Link> */}
              {/* <Link className={`navbar-item ${this.pathIncludes('journal')}`} to="/journal">
                <p>Journal</p>
              </Link> */}
              <Link className="navbar-item" to="/#footer" onClick={() => this.closeHamburger()}>
                <p>Contact</p>
              </Link>
              {/* <Link className="navbar-item" to="/contact/examples">
                Form Examples
              </Link> */}
            </div>
            {this.state.active
              ? (
                <div className="navbarFooter">
                  <p className="navbarFooter--item">TOM@ORTOM.AI</p>
                  <p className="navbarFooter--item">
                    <a
                      href="https://www.linkedin.com/in/tomliptrot1/"
                    >
                      LINKEDIN
                    </a>
                  </p>
                  <p className="navbarFooter--item">
                    <a
                      href="https://clutch.co/profile/ortom"
                    >
                      CLUTCH.CO
                    </a>
                  </p>
                </div>
              )
              : <div />}
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
